// export const lessons = (state) => {
//   let lessons = state.learnLessons.map((row) => {
//     return [...row.withoutShift, ...row.withShift];
//   }).flat();
//   return lessons; //state.lessons;
// };

export const hasLesson = (state) => {
  return (lid) => {
    return state.listEnglishTypingPassages.find((el) => el.id == lid)
      ? true
      : false;
  };
};

export const getLesson = (state) => {
  return (lid) => {
    let lsn = state.listEnglishTypingPassages.find((el) => el.id == lid);
    return Promise.resolve(lsn);
  }; //state.lessons;
};
